import { INTERNAL_SERVER_ERROR, UNAUTHORIZED } from 'shared-module/api/httpStatusCode'

const isHandled = (error) => error.response.status === UNAUTHORIZED || error.response.status === INTERNAL_SERVER_ERROR

const errorState = { isHandled }
export default errorState
